




























import { Vue, Component, Prop } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import { Pair, PairItem, MatchingCorrectAnswer } from './matching-question-component.vue';
import * as Api from "@/app/question/components/api";

interface SolutionPair {
  left: string | null;
  right: string | null;
  correct: boolean;
}

@Component
export default class MatchingQuestionSolutionComponent extends Vue implements Api.QuestionSolutionProps2<Pair[], MatchingCorrectAnswer> {
  @Prop({
    required: true,
  })
  public userAnswer: Pair[];

  @Prop({
    required: true,
  })
  public correctAnswer: MatchingCorrectAnswer;

  private get pairs(): SolutionPair[] {
    let pairs: SolutionPair[] = [];

    // answered
    this.userAnswer.forEach((pair: Pair) => {
      const left: string = `${pair.concept.id}-${pair.definition.id}`;
      const pairId: string = this.findIdByPairId(pair.concept.pairId);
      const right: string = `${pair.concept.id}-${pairId}`;
      console.log(pair.concept.id, pair.definition.pairId);
      const correct: boolean = pair.definition.id === pairId;
      pairs.push({
        left,
        right,
        correct
      });
    });

    // not answered
    this.correctAnswer.concepts.forEach((c) => {
      const right = `${c.id}-${this.findIdByPairId(c.pairId)}`;
      pairs.push({
        left: null,
        right,
        correct: false
      });
    });

    return pairs;
  }

  findIdByPairId(pairId: string) {
    const filteredDefs = this.correctAnswer.definitions.filter(def => def.pairId === pairId);

    if (filteredDefs.length) {
      return filteredDefs[0].id;
    }

    return pairId;
  }

  private t(key: string, params: any = {}) {
    return i18n.t(key, params);
  }
}
